const Emails = {
    Hello: 'hello@geekbattle.online',
    Dev: 'dev@geekbattle.online',
    Admin: 'admin@geekbattle.online',
    Info: 'info@geekbattle.online',
}

export default Emails
